import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress, {
    linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#0000001A',
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },
}));
interface IPercentChartProps {
    title: string;
    data: { value: number; name: string }[];
}
const PercentChart: React.FC<IPercentChartProps> = ({ title, data }) => {
    return (
        <Box>
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: '28px',
                    textAlign: 'left',
                    lineHeight: '33.89px',
                    mb: 2,
                }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                {data.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: '400',
                                    fontSize: '18px',
                                }}
                            >
                                {item.name}
                            </Typography>
                            <Typography
                                sx={{
                                    fontWeight: '600',
                                    fontSize: '18px',
                                }}
                            >
                                {item.value}%
                            </Typography>
                        </Box>
                        <BorderLinearProgress
                            key={index}
                            variant="determinate"
                            value={item.value}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PercentChart;
